module.exports = __webpack_public_path__ + "img/list27.1866fdc2.jpeg";